import usePaginatedLogList from "../../../../hooks/usePaginatedLogList";
import LogListError from "../../../../components/LogListError";
import React, { useEffect, useState } from "react";
import { Button, Table, Space, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { ApiURL, odsRefrigerantPdfUrl } from "../../../../services/apiConstants";
import { PlusOutlined, EyeFilled, EditOutlined } from "@ant-design/icons";
import moment from "moment";
import { DOWNLOADPDF } from "../../../../utils/downloadPdf";
import dayjs from "dayjs";
import { dateRanges } from "../../../../Data/data";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

const ListSupplyAndDischargeLog = () => {
  const navigate = useNavigate();
  const { data: data, loading: loading, load: loadRecords, pagination, error, retry } =
    usePaginatedLogList(ApiURL.supply_and_discharge, "data");
  const [filter, setFilter] = useState("all");
  const [dates, setDates] = useState([dayjs().subtract(1, "month"), dayjs()]);
  const [startDate, endDate] = dates?.map((d) => d.format("YYYY-MM-DD")) || [];

  const userData = JSON.parse(localStorage.getItem("user_data"));
  const shipId = userData?.data?.ship_details?.ship_id;
  const designation = userData?.data?.designation;

  const ALLOWED_DESIGNATIONS = ["Electrical Engineer"];
  const canAddOdsRecord = ALLOWED_DESIGNATIONS.includes(designation);
  const CAN_EDIT_ROLES = ["Electrical Engineer", "Chief Engineer"];

  const LIST_API = (selectedFilter = filter, selectedShip = shipId) => {
    if (!selectedShip) return;
    return loadRecords({ ship_id: selectedShip, ...(selectedFilter !== "all" ? { filter: selectedFilter } : {}) });
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const handleFilterChange = (value) => {
    setFilter(value);
    LIST_API(value);
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      align: "center",
      render: (date) => (date ? moment(date).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "Supply (kg)",
      dataIndex: "supply_of_ods_kgs",
      align: "center",
    },
    {
      title: "Deliberate Discharge",
      dataIndex: "deliberate_discharge_kgs",
      align: "center",
    },
    {
      title: "Non-Deliberate Discharge",
      dataIndex: "non_deliberate_discharge_kgs",
      align: "center",
    },
    {
      title: "Shore Discharge",
      dataIndex: "discharge_to_shore_kgs",
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Record">
            <Button
              type="primary"
              size="small"
              icon={<EyeFilled />}
              onClick={() =>
                navigate(`/view-supply-and-discharge-log/${record?.id}`)
              }
            />
          </Tooltip>
          {
            record?.status === "pending" && (
              <Tooltip title="Edit Record">
              <Button
                type="primary"
                size="small"
                icon={<EditOutlined />}
                onClick={() =>
                  navigate(`/edit-supply-and-discharge-log/${record?.id}`)
                }
              />
            </Tooltip>
            )
          }
        </Space>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <h2 style={{ margin: 0 }}>Supply and Discharge Log</h2>

        
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <Space>
          <div style={{ marginRight: "10px" }}>
            <RangePicker
              presets={dateRanges}
              value={dates}
              onChange={setDates}
              format="YYYY-MM-DD"
              style={{ width: 300 }}
              disabledDate={(current) => current && current > dayjs().endOf("day")}
            />
          </div>
          <Button
            type="primary"
            onClick={() =>
              DOWNLOADPDF(odsRefrigerantPdfUrl, shipId, startDate, endDate)
            }
          >
            Download PDF
          </Button>
        </Space>
        <Space>
          <Button
            type={filter === "all" ? "primary" : "default"}
            onClick={() => handleFilterChange("all")}
          >
            All
          </Button>
          <Button
            type={filter === "pending" ? "primary" : "default"}
            onClick={() => handleFilterChange("pending")}
          >
            Pending
          </Button>
          <Button
            type={filter === "approved" ? "primary" : "default"}
            onClick={() => handleFilterChange("approved")}
          >
            Approved
          </Button>
          <Button
            type={filter === "no_record" ? "primary" : "default"}
            onClick={() => handleFilterChange("no_record")}
          >
            No Record
          </Button>

          

          <Button
              icon={<PlusOutlined />}
              type="primary"
              className="save_btn"
              onClick={() => navigate("/add-supply-and-discharge-log")}
            >
              Add Supply and Discharge Log
            </Button>
        </Space>
      </div>

      <LogListError error={error} retry={retry} />
      <Table
        bordered
        loading={loading}
        columns={columns}
        dataSource={data}
        rowKey="id"
        className="custom-table"
        pagination={pagination}
      />
    </>
  );
};

export default ListSupplyAndDischargeLog;
